import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './reset.css';
import './theme/theme.css'; // Import theme CSS
import './theme/css-variables-fix.css'; // Import CSS variables fix
import App from './App';
import ThemeProvider from './theme/ThemeProvider'; // Import ThemeProvider

// Initialize auth state manager early
import './utils/authStateManager';

// Import the navigation fixes and initialize them
import { initializeAllFixes, ResizeObserverManager } from './utils';

// Import styled-components patch to ensure theme is always available
import './theme/styled-components-patch';

// Import theme spacing patch to ensure spacing is always available
import './utils/theme-spacing-patch';

// Initialize all fixes (ResizeObserver, SVG, theme)
// This applies fixes and sets up navigation event listeners
initializeAllFixes();

// Initialize the ResizeObserverManager singleton as a backup
ResizeObserverManager.getInstance();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Register service worker for offline support (disabled in development)
if ('serviceWorker' in navigator && process.env.NODE_ENV !== 'development') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered:', registration);
        
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60000); // Check every minute
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
} else if ('serviceWorker' in navigator && process.env.NODE_ENV === 'development') {
  // Unregister any existing service workers in development
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('Service Worker unregistered for development');
    }
  });
}
